import React from "react";

import * as urls from "../urls";
import { VerticalBreadcrumbs } from "Common/Breadcrumbs/VerticalBreadcrumbs";
import { Grid } from "Common/Grid";
import { Div } from "Common/HTML";
import SplitPage from "Common/SplitPage";

import makeBem from "Utils/makeBem";

const bem = makeBem("Layout");

const crumbs = [
  {
    sectionName: "payment",
    title: "Purchase Subscription",
    link: urls.paymentURL,
    status: "complete",
  },
  {
    sectionName: "additionalInformation",
    title: "Benefits Information",
    link: urls.additionalInformationURL,
    status: "incomplete",
  },
  {
    sectionName: "done",
    title: "Done",
    link: urls.doneURL,
    status: "incomplete",
  },
];

const getBreadcrumbs = () =>
  crumbs.map((crumb) => {
    let { status } = crumb;
    if (window.location.pathname.includes("done")) {
      status = "complete";
    } else if (window.location.pathname.includes(crumb.link)) {
      status = "current";
    }
    return { ...crumb, status };
  });

const Layout = ({ children }) => (
  <Grid>
    <SplitPage.Wrapper className="min-h-dvh">
      <SplitPage.Main px={0}>{children}</SplitPage.Main>
      <SplitPage.Aside>
        <div className={bem("wizardPlacement")}>
          <VerticalBreadcrumbs crumbs={getBreadcrumbs()} />
        </div>
      </SplitPage.Aside>
    </SplitPage.Wrapper>
  </Grid>
);

export default Layout;
